import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=70c536f3&scoped=true&"
var script = {}
import style0 from "./tables.vue?vue&type=style&index=0&id=70c536f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c536f3",
  null
  
)

export default component.exports